import React from 'react';
import { useUserLocation } from 'Account/hooks';
import {
  FindMatchButton,
  SessionAllowance,
  PractitionerCardList,
  LocationModal,
  LocationModalPage,
  FilterKey,
  FiltersCollection,
} from 'Book/shared';

import { Filters } from './components';
import { Wrapper } from './styles';

interface TalkBrowsePageProps {
  selectedFilters: FiltersCollection;
  onFilterChange(filter: FiltersCollection): void;
  lastAddedFilterKey?: FilterKey;
  onRemoveFilter(key: FilterKey): void;
}

export default ({
  selectedFilters,
  onFilterChange,
  lastAddedFilterKey,
  onRemoveFilter,
}: TalkBrowsePageProps) => {
  const { userLocationData } = useUserLocation();

  return (
    <>
      <Wrapper>
        <header>
          <SessionAllowance />
          <FindMatchButton />
        </header>
        <Filters
          selectedFilters={selectedFilters}
          onFiltersChange={onFilterChange}
          userLocation={userLocationData?.user ?? null}
        />
        <PractitionerCardList
          filters={selectedFilters}
          lastAddedFilterKey={lastAddedFilterKey}
          onRemoveFilter={onRemoveFilter}
        />
      </Wrapper>
      <LocationModal page={LocationModalPage.Browse} />
    </>
  );
};
